<template lang="pug">
#news
  .container.custom_container_lg
    .row
      breadcrumb
  section.container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12
        h2.title 新聞快遞
    news-item(
      v-for="(news, index) in currentNewsList",
      :key="index",
      :news="news",
      :direction="index % 2",
      :type="'news'"
    )
  .row.i_mt_8
    .col-12.text.center.justify-content-center
      b-pagination(
        v-model="newsCurrentPage",
        :total-rows="newsTotalRows",
        :per-page="newsPerPage",
        first-number,
        last-number
      )
  section.container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12
        h2.title 公吿資訊
    .row
      announcement(
        v-for="(announcement, index) in currentAnnouncementList",
        :key="index",
        :announcement="announcement"
      )
    .row.i_mt_8
      .col-12.text.center.justify-content-center
        b-pagination(
          v-model="announcementCurrentPage",
          :total-rows="announcementTotalRows",
          :per-page="announcementPerPage",
          first-number,
          last-number
        )
  // Google Tag Manager (noscript)
  noscript
    iframe(src="https://www.googletagmanager.com/ns.html?id=GTM-MK9D2SM3" height="0" width="0" style="display:none;visibility:hidden")
  // End Google Tag Manager (noscript)
</template>

<script>
import Announcement from "@/components/about_us/news/Announcement";
import NewsItem from "@/components/about_us/news/NewsItem";
import { getNews, getAnnouncement } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "News",
  components: {
    announcement: Announcement,
    breadcrumb: Breadcrumb,
    "news-item": NewsItem,
  },
  // head: {
  //   script: [
  //     {
  //       inner: `
  //         <!-- Google Tag Manager -->
  //         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  //         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  //         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  //         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  //         })(window,document,'script','dataLayer','GTM-MK9D2SM3');
  //         <!-- End Google Tag Manager -->
  //       `,
  //     },
  //   ],
  // },
  data() {
    return {
      newsTotalRows: 0,
      newsPerPage: 3,
      newsCurrentPage: 1,
      currentNewsList: [],
      news: {},

      announcementTotalRows: 0,
      announcementPerPage: 3,
      announcementCurrentPage: 1,
      currentAnnouncementList: [],
      announcement: {},

      totalRows: 0,
      perPage: 3,
      currentPage: 1,
    };
  },
  watch: {
    newsCurrentPage() {
      this.getCurrentNewsList();
    },
    announcementCurrentPage() {
      this.getCurrentAnnouncementList();
    },
  },
  created() {
    this.getNews();
    this.getAnnouncement();
  },
  methods: {
    getNews() {
      getNews().then((response) => {
        this.news = response.data;
        this.newsTotalRows = response.data.NewsList.length;
        this.getCurrentNewsList();
      });
    },
    getAnnouncement() {
      getAnnouncement().then((response) => {
        this.announcement = response.data;
        this.announcementTotalRows = response.data.AnnouncementList.length;
        this.getCurrentAnnouncementList();
      });
    },
    getCurrentNewsList() {
      this.currentNewsList = [];
      let number = this.newsPerPage * this.newsCurrentPage;
      this.currentNewsList = this.news.NewsList.slice(
        number - this.newsPerPage,
        number
      );
    },
    getCurrentAnnouncementList() {
      this.currentAnnouncementList = [];
      let number = this.announcementPerPage * this.announcementCurrentPage;
      this.currentAnnouncementList = this.announcement.AnnouncementList.slice(
        number - this.announcementPerPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
@import "@/assets/style/about_us/news";
</style>
